import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import MoodIcon from '@material-ui/icons/Mood';
import MoodTwoToneIcon from '@material-ui/icons/MoodTwoTone';
import Tooltip from '@material-ui/core/Tooltip';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
//import { toImage } from 'emoji-toolkit/lib/js/joypixels';
import 'emoji-toolkit/extras/css/joypixels.css';

import windowActions from '../actions/window_actions';

import '../../src/index.css';

export class ChatBoxCompose extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: this.props.messages, // messages passed down from ChatBoxWindow parent
            sendMessage: "",
            showEmoji: false,
        };
    }

    /*
    Given string "Hi :grinning: how are you?".
    Return "Hi :) how are you?"
    
    var allEmojisObj = [{id: "grinning", name: "Grinning Face", short_names: ["grinning"], skin: null, unified: "1f600", colons: ":grinning:", native: ":)", emoticons: []}, {...}, {...}, ...];
    
      convertColonsToEmoji = (messageToBeSent) => {
        //iterate through message
        //if message includes ":emojiId:"
          //iterate through every emoji object
            //if :emojiId: is a value for the "colons" property
              //then grab that emoji object's "native" property
            //else do nothing
        //else do nothing
      };
     */

    sendMessage = () => {
        var tempMessages = this.state.messages.slice();
        tempMessages.push({ isOwner: true, message: this.state.sendMessage });
        this.setState({ messages: tempMessages, sendMessage: "" });
        this.props.callbackFromParent({ userId: this.props.profile.id, createAt: (new Date().getTime()), message: this.state.sendMessage });
    };

    handleClickSendMessage = (e) => {
        console.log("clicked message sent " + e);
        if (this.state.sendMessage !== "") {
            //this.convertColonsToEmoji(this.state.sendMessage);
            this.sendMessage();
        }
    };

    handleEnterSendMessage = (e) => {
        if (e.key === "Enter" && this.state.sendMessage !== "") {
            console.log("enter message sent: " + e.target.value);
            e.preventDefault();
            //this.convertColonsToEmoji(this.state.sendMessage);
            this.sendMessage();
        }
    };

    //getCurrentTime = () => {
    //  var today = new Date();
    //  var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    //  var time = today.getHours() + ":" + today.getMinutes();
    //  var dateTime = date + ' ' + time;
    //  return dateTime;
    //}

    handleChange = property => event => {
        this.props.unreadCallback();
        var tempState = {};
        tempState[property] = event.target.value;
        this.setState(tempState);
    };

    handleShowEmoji = () => {
        this.setState({ showEmoji: !this.state.showEmoji });
    };

    addEmoji = (e) => {
        console.log("child e: ", e); // {grinning emoji object}
        console.log("child COLONSSSSS: ", e.colons); // :grinning:
        console.log("child e.native: ", e.native); // actual emoji
        let emoji = e.native;
        this.setState({
            sendMessage: this.state.sendMessage + emoji,
            showEmoji: false
        })
    };

    render() {
        let emojiPicker;
        let emojiButton;

        if (this.state.showEmoji) {
            emojiPicker =
                <Picker
                    set='messenger'
                    title='Pick emoji'
                    emoji='point_up'
                    style={{ position: 'absolute', bottom: '70px', right: '10px' }}
                    perLine={8}
                    onSelect={this.addEmoji}
                    showSkinTones={false}
                />;
        }

        if (this.state.showEmoji) {
            emojiButton = <MoodTwoToneIcon style={{ fontSize: '2.5rem', color: '#3f51b5' }} />;
        } else {
            emojiButton = <MoodIcon style={{ fontSize: '2.5rem' }} />;
        }

        return (

            <Grid container item xs={12} spacing={0} style={{ position: 'fixed', bottom: '0', height: '80px' }}>

                <Grid item xs={11}>
                    <TextField
                        autoFocus
                        ref={(ip) => this.myInput = ip}
                        id="outlined-multiline-static"
                        placeholder="Write a message..."
                        fullWidth
                        multiline
                        rows="3"
                        margin="normal"
                        variant="outlined"
                        inputProps={{ style: { fontSize: '13px', padding: '0px', margin: '-5px', lineHeight: '16px' } }}
                        style={{ marginLeft: '10px', backgroundColor: 'white', marginTop: '-4px', paddingRight: '22px' }}
                        value={this.state.sendMessage}
                        onChange={this.handleChange('sendMessage')}
                        onKeyPress={this.handleEnterSendMessage}
                    />
                </Grid>

                <Grid container item xs={1} spacing={0}>

                    <Grid item xs={12} style={{}}>
                        <IconButton title={'Emojis'} onClick={this.handleShowEmoji} style={{ backgroundColor: 'white', padding: '0px', marginTop: '6px' }}>
                            {emojiButton}
                        </IconButton>
                    </Grid>

                    <Grid item xs={12} style={{ paddingBottom: '25px' }}>
                        <IconButton title={'Send Message'} onClick={this.handleClickSendMessage} style={{ backgroundColor: 'white', padding: '0px', marginTop: '6px' }}>
                            <SendIcon style={{ fontSize: '2.5rem' }} />
                        </IconButton>
                    </Grid>

                </Grid>
                {emojiPicker}
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        members: state.members,
        profile: state.profile,
        currentUser: state.currentUser,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
    };
}

const mapDispatchToProps = dispatch => ({
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBoxCompose);


// WEBPACK FOOTER //
// ./src/components/ChatBoxCompose.js


// WEBPACK FOOTER //
// ./src/components/ChatBoxCompose.js